export default {
    methods: {
        executeRecaptcha()
        {
            return new Promise( resolve =>
            {
                window.grecaptcha.execute( window._rootData.recaptchaSitekey, { action: 'register' })
                    .then( function( token )
                    {
                        window.recaptchaToken = token;
                        resolve();
                    });
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/mixins/recaptcha.js